<template>
  <section class="legalHome">
    <div class="legalwraper">
      <div class="imgwrap">
        <div class="img logo01">
          <img src="../../assets/logo01.png" alt="" />
        </div>
        <div class="dividing"></div>
        <div class="img logo02">
          <img :src="legaldata.insLogoUrl" />
        </div>
      </div>
      <div class="smalltit">
        <p class="stxt">本产品由{{ legaldata.insFullName }}承保<br />由天津华盛保险经纪有限公司提供服务</p>
      </div>
      <div class="bigtit">
        <p class="btxt">您即将进入到天津华盛保险经纪产品销售页面，请认真阅读：</p>
      </div>
      <div class="mtit">
        <p class="mtxt">
          本产品由天津华盛保险经纪有限公司提供经纪服务保险产品；由
          {{ insuranceCompanyName }}
          承保。本产品已向中国保险行业协会报备，投保时请认真阅读保险承保方案、投保须知、保险条款、免责条款、<span style="color: #1776ff" @click.stop="jumpPage">客户告知书</span>
          等。
        </p>
        <p class="mtxt">
          为您与保险公司缔结、履行保险合同，我们将在您进入本页面后通过运车旺惠保平台收集并向保险公司共享您的姓名、手机号、证件号、订单信息等，其中证件号属于个人敏感信息，具体共享信息以投保时填写的内容为准；为保障您的权益，依照国家金融监管总局相关要求，投保过程将被记录并加密存储，并同步承保保险公司。
        </p>
      </div>
      <div class="binfowrap">
        <div class="binfo">客服电话：400-000-7535</div>
        <div class="binfo">查询保单：关注公众号“车旺惠保”可查询保单</div>
        <div class="binfo">平台服务：由insapp.hsbxjj.com提供</div>
      </div>
      <div class="closewrap">
        <span class="closebtn" @click="closePage()">我知道了</span>
      </div>
    </div>
  </section>
</template>

<script>
// import {myTrack} from "../../common/js/zhuge";
import { getUrlParams } from "../../common/utils";

export default {
  name: "legalHome",
  components: {},
  data() {
    return {
      insuranceCompanyName: "",
      legaldata: {},
    };
  },
  mounted() {
    this.legal();
  },
  methods: {
    jumpPage() {
      //跳转页面
      this.$router.push({ path: "/notice" });
    },
    closePage() {
      this.$emit("closeLegal");
      //    this.$router.go(-1);
    },
    legal() {
      //获取合规信息
      // this.$loading.show();
      let data = {
        productCode: getUrlParams().productCode,
      };
      let url = "/hsbxjj-standard-common-insurance/standardinsurance/companyInfo";
      this.$http
        .post(url, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.legaldata = res.data.data;
          try {
            this.insuranceCompanyName = res.data.data.insSimpleName ? res.data.data.insSimpleName + "保险公司" : res.data.data.insFullName;
          } catch (error) {}
          this.$loading.hide();
        })
        .catch((error) => {
          this.$loading.hide();
        });
      //获取合规信息
    },
  },
};
</script>

<style scoped lang="scss">
@import "legalHome.scss";
</style>
